import {
  ExternalCalendarEvent,
  ExternalCalendarEventPreview,
} from '@griply/types';

// Omitted keys are left out, not defaulted — an invented `guestCount: 0` would hide a real guest row.
export const getExternalCalendarEventPreview = ({
  location,
  busy,
  videoCallUrl,
  videoCallProvider,
  hasDescription,
  guestCount,
  isOrganizer,
  isRecurring,
}: ExternalCalendarEvent): ExternalCalendarEventPreview => ({
  ...(location !== undefined && { location }),
  ...(busy !== undefined && { busy }),
  ...(videoCallUrl !== undefined && { videoCallUrl }),
  ...(videoCallProvider !== undefined && { videoCallProvider }),
  ...(hasDescription !== undefined && { hasDescription }),
  ...(guestCount !== undefined && { guestCount }),
  ...(isOrganizer !== undefined && { isOrganizer }),
  ...(isRecurring !== undefined && { isRecurring }),
});
